import { shuffle } from 'lodash';
import { defaultState } from './stores';
import { get5RandomFamilyMembersToMatch } from '../store/selectors';


export const setActualCards = store => store.update(state => {
    const actImagesToMatch = get5RandomFamilyMembersToMatch(state);
    return {
        ...state,
        frontImagesOrder: actImagesToMatch,
        backImagesOrder: shuffle(actImagesToMatch),
        selectedFrontImage: undefined,
        selectedBackImage: undefined,
    }
});

export const setSelectedFrontImage = (store, cardId) => store.update(state => ({
    ...state,
    selectedFrontImage: cardId
}));

export const setSelectedBackImage = (store, cardId) => store.update(state => ({
    ...state,
    selectedBackImage: cardId
}));

export const setSelectedFrontAndBackImage = (store, cardId) => {
    setSelectedFrontImage(store, cardId);
    setSelectedBackImage(store, cardId);
}

export const addCardToMatched = (store, cardId) => store.update(state => ({
    ...state,
    matchedImages: state.matchedImages.push(cardId)
}));

export const addCardToSelectedFrontImage = (store, cardId) => store.update(state => {
    const selectedFrontImage = state.selectedFrontImage;

    if (selectedFrontImage) {
        return state;
    }

    const selectedBackImage = state.selectedBackImage;
    const isMatching = selectedBackImage && (cardId === selectedBackImage);
    
    if (isMatching) {
        addCardToMatched(store, cardId);

        return {
            ...state,
            selectedFrontImage: cardId
        };
    } else if (!selectedBackImage) {
        return {
            ...state,
            selectedFrontImage: cardId
        };
    }

    return state;
});

export const addCardToSelectedBackImage = (store, cardId) => store.update(state => {
    const selectedBackImage = state.selectedBackImage;

    if (selectedBackImage) {
        return state;
    }

    const selectedFrontImage = state.selectedFrontImage;
    const isMatching = selectedFrontImage && (cardId === selectedFrontImage);

    if (isMatching) {
        addCardToMatched(store, cardId);
        return {
            ...state,
            selectedBackImage: cardId
        };
    } else if (!selectedFrontImage) {
        return {
            ...state,
            selectedBackImage: cardId
        };
    }

    return state;
});

export const resetSelectedImages = store => store.update(state => ({
    ...state,
    selectedFrontImage: undefined,
    selectedBackImage: undefined
}));

export const resetState = store => store.update(state => ({
    ...defaultState,
    matchedImages: [],
    isFinalSceneActive: false
}));

export const startFinalScene = store => store.update(state => ({
    ...state,
    isFinalSceneActive: true
}));
